export const AUTHENTICATED = "AUTHENTICATED";
export const UNAUTHENTICATED = "UNAUTHENTICATED";
export const AUTHENTICATION_ERROR = "AUTHENTICATION_ERROR";
export const UNHELPFULTOKEN = "UNHELPFULTOKEN";
export const VERSIONCHANGE = "VERSIONCHANGE";
export const REFRESHTOKEN = "REFRESHTOKEN";
export const CONNECTEDSIGNALR = "CONNECTEDSIGNALR";
export const CONSOLELOG = "CONSOLELOG";

export const ENTERED = "ENTERED";
export const RESETERROR = "RESETERROR";
export const TABALIVE = "TABALIVE";

export const LOAD_TRANSLATIONS = "LOAD_TRANSLATIONS";
export const SET_LOCALE = "SET_LOCALE";

// userPref's
export const CURRENTENTITY = "CURRENTENTITY";
export const TREEMENUWIDTH = "TREEMENUWIDTH";
export const SETTINGSMENUWIDTH = "SETTINGSMENUWIDTH";
export const UPDATEENTITYTREE = "UPDATEENTITYTREE";
export const UPDATESPECIFICNODE = "UPDATESPECIFICNODE";
export const QUICKSEARCHFILTER = "QUICKSEARCHFILTER";
export const SEARCHCATEGORIES_IMMEDIATE = "SEARCHCATEGORIES_IMMEDIATE";
export const MAXRESULTCOUNT = "MAXRESULTCOUNT";
export const TREEVIEWNODEEXPAND = "TREEVIEWNODEEXPAND";
export const DIFFERENTENTITYSELECTED = "DIFFERENTENTITYSELECTED";
export const UPDATEHIGHLIGHTEDROWS = "UPDATEHIGHLIGHTEDROWS";
export const MAPPREF = "MAPPREF";
export const INITIALIZEPREFS = "INITIALIZEPREFS";
export const QUICKSEARCH = "QUICKSEARCH";
export const ISFETCHING = "ISFETCHING";
export const NEXTFOLLOWEDUSERROUTE = "NEXTFOLLOWEDUSERROUTE"; // Should be renamed in : NEXTFOLLOWEDUSERROUTE 
export const NEWNOTIFCOUNT = "NEWNOTIFCOUNT";

// bookmarks
export const MENUBOOKMARKED = "MENUBOOKMARKED";
export const MENUUNBOOKMARKED = "MENUUNBOOKMARKED";

export const SEARCHTEXTCHANGED = "SEARCHTEXTCHANGED";
export const HIDENEWFEATURESPOPUP = "HIDENEWFEATURESPOPUP";
export const UPDATESHEETNAME = "UPDATESHEETNAME";
export const UPDATEDATAVALIDATIONPROGRESS = "UPDATEDATAVALIDATIONPROGRESS";
export const UPDATEENTITIESLIST = "UPDATEENTITIESLIST";
export const REFRESH_GLOBALSEARCHBAR = "REFRESH_GLOBALSEARCHBAR";
export const UPDATEBRANCHESANDCOUNTRIES = "UPDATEBRANCHESANDCOUNTRIES";
export const REFRESHRECYCLEBINGRID = "REFRESHRECYCLEBINGRID";
export const SHOW_ADVANCED_SEARCH_CRITERIAS = "SHOW_ADVANCED_SEARCH_CRITERIAS";
export const UPDATE_ENTITIES_RESULTS = "UPDATE_ENTITIES_RESULTS";
export const UPDATE_DOCUMENTS_RESULTS = "UPDATE_DOCUMENTS_RESULTS";
export const UPDATE_STATIONS_RESULTS = "UPDATE_STATIONS_RESULTS";
export const UPDATE_ZONES_RESULTS = "UPDATE_ZONES_RESULTS";
export const UPDATE_SAMPLINGS_RESULTS = "UPDATE_SAMPLINGS_RESULTS";
export const CLEAR_SEARCH_RESULTS = "CLEAR_SEARCH_RESULTS";
export const FILTER_CRITERIAS_UPDATED = "FILTER_CRITERIAS_UPDATED";

export const AUTH_UPDATE_EXTERNAL_PROVIDER_TOKEN = "AUTH_UPDATE_EXTERNAL_PROVIDER_TOKEN";